import { motion, useReducedMotion } from "framer-motion";

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = "left",
  testidPrefix = "section",
}) {
  const reduced = useReducedMotion();
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <motion.div
      initial={reduced ? false : { opacity: 0, y: 10 }}
      whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      className={`max-w-2xl ${alignCls}`}
    >
      {eyebrow && (
        <div
          data-testid={`${testidPrefix}-eyebrow`}
          className="text-[11px] uppercase tracking-[0.22em] text-terracotta font-semibold mb-3"
        >
          {eyebrow}
        </div>
      )}
      <h2
        data-testid={`${testidPrefix}-title`}
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] leading-[1.08] text-ink"
      >
        {title}
      </h2>
      {subtitle && (
        <p
          data-testid={`${testidPrefix}-subtitle`}
          className="mt-4 text-ink-muted text-base sm:text-lg leading-[1.7] max-w-prose"
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
